"use strict";


/*****************
 ** WEBPACK FOOTER
 ** ./components/locale-provider/style/index.js
 ** module id = 215
 ** module chunks = 0
 **/